"use strict";

import { ModalService } from './service';
import { OnDestroy, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { ModalFooterComponent } from './modalfooter/component';
import { ModalAction } from './modalfooter/modalaction';
import {Tools} from "linkurious-shared";
import {AbstractModalComponent} from "./abstractmodal";
import {SafeHtml} from "@angular/platform-browser";

export abstract class AbstractConfirmComponent extends AbstractModalComponent {

  public title: SafeHtml;
  public content: SafeHtml;


  protected constructor(
    protected _modal: ModalService
  ) {
    super(_modal);
  }
}
